import { createContext } from "react";

export const SelectedPlanContext = createContext({})


// WEBPACK FOOTER //
// ./resources/assets/js/flipToFibre/SelectedPlanContext.js